// extracted by mini-css-extract-plugin
export default {"borderDtmood":"FraseDelDia_borderDtmood__f6RSo"};